import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatMenu } from '@angular/material/menu';
import * as fromAuth from '../../../../store/auth';
import * as fromEvents from '../../../customer-shared/tracking/events';
import * as fromAuthEvents from '../../../auth/tracking/auth.events';
import { TrackingService } from '../../services/tracking.service';
import { UserSettingsService } from '../../services/user-settings.service';

// The account menu shared by the customer header and the mobile page header. The headers keep their
// own button (styled for their bar) and open this with [matMenuTriggerFor]="accountMenu.menu".
@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  standalone: false,
})
export class AccountMenuComponent {
  @ViewChild('menu', { static: true }) menu: MatMenu;

  user$ = this.store.select(fromAuth.selectUser);
  isAdmin$ = this.store.select(fromAuth.selectIsAdmin);

  // Each language in its own name, so it can be found whatever language the app is in.
  languages = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
  ];
  currentLanguage = this.languages.find(l => l.code === this.userSettings.getSelectedLanguage().slice(0, 2)) ?? this.languages[0];

  constructor(
    private store: Store<{ auth: fromAuth.AuthState }>,
    private router: Router,
    private tracking: TrackingService,
    private userSettings: UserSettingsService,
  ) {}

  goToNotifications() {
    this.router.navigate(['/user/profile'], { fragment: 'notifications' });
  }

  setLanguage(code: string) {
    if (code !== this.currentLanguage.code) this.userSettings.setLanguage(code);
  }

  goToProfile() {
    this.tracking.track(fromEvents.accountClicked());
    this.router.navigate(['/user/profile']);
  }

  logout() {
    // Tracked before the dispatch: the logout effect resets the Mixpanel identity synchronously.
    this.tracking.track(fromAuthEvents.logoutEvent());
    this.store.dispatch(fromAuth.logout());
  }
}
